import React from "react";
import {Route} from "react-router-dom";
import ContingencyTrustContainer from "../../pages/operation/contingencyTrust";
import ContingencyTrustBbvaContainer from "../../pages/operation/contingencyTrustBBVA";
import CustodyTitlesContainer from "../../pages/operation/custodyTitles";
import {
    CONFIRM_EXTENSION_ADMIN_ROUTE,
    CONTINGENCY_TRUST_ROUTE,
    INSERT_EXTENSION_ADMIN_ROUTE,
    INSERT_ORDER_TRADE_ADMIN_ROUTE,
    TAKE_ORDER_ADMIN_ROUTE,
    UPDATE_ORDER_ADMIN_ROUTE,
    CONTINGENCY_TRUST_BBVA_ROUTE,
    CUSTODY_TITLES_ROUTE,
    MASSIVE_AGREEMENT_ROUTE
} from "../../utils/constants/RoutesConstants";
import ConfirmExtensionContainer from "../../pages/controlPanel/confirmExtension/ConfirmExtensionContainer";
import InsertExtensionAdminContainer
    from "../../pages/operation/extensionAdmin/insertExtensionAdmin/InsertExtensionAdminContainer";
import InsertOrderTradeAdminContainer
    from "../../pages/operation/orderAdmin/insertOrderTradeAdmin/InsertOrderTradeAdminContainer";
import UpdateOrderAdminContainer from "../../pages/operation/orderAdmin/updateOrderAdmin/UpdateOrderAdminContainer";
import TakeOrderAdminContainer from "../../pages/operation/orderAdmin/takeOrderAdmin/TakeOrderAdminContainer";
import MassiveAgreementContainer from "../../pages/operation/massiveAgreement/MassiveAgreementContainer";


const OperationRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CONTINGENCY_TRUST_ROUTE} component={ContingencyTrustContainer}/>
            <Route path={CONTINGENCY_TRUST_BBVA_ROUTE} component={ContingencyTrustBbvaContainer}/>
            <Route path={CUSTODY_TITLES_ROUTE} component={CustodyTitlesContainer}/>

            <Route path={CONFIRM_EXTENSION_ADMIN_ROUTE} component={ConfirmExtensionContainer}/>
            <Route path={INSERT_EXTENSION_ADMIN_ROUTE} component={InsertExtensionAdminContainer}/>

            <Route path={INSERT_ORDER_TRADE_ADMIN_ROUTE} component={InsertOrderTradeAdminContainer}/>
            <Route path={UPDATE_ORDER_ADMIN_ROUTE} component={UpdateOrderAdminContainer}/>
            <Route path={TAKE_ORDER_ADMIN_ROUTE} component={TakeOrderAdminContainer}/>

            <Route path={MASSIVE_AGREEMENT_ROUTE} component={MassiveAgreementContainer}/>
        </React.Fragment>
    );
};

export default OperationRoutes;